export default __webpack_public_path__ + "static/media/YAS0050.34I-27668_-26111_0.247a763d.jpg";